<template>
  <v-row>
    <v-col>
      <v-row dense>
        <v-col cols="3">
          <QuerySearchDropdown
            v-model="medicine"
            :query="getMedicinesQuery"
            :query-key="['medicines', 'collection']"
            label="Medicamento"
            item-text="name"
            input-prompt-text="Digite para pesquisar..."
            not-found-text="Nenhum medicamento encontrado."
            :disabled="allowEdit"
            :error-messages="errors.medicine"
            :additional-variables="{
              disabled: false,
              applicationRouteId: applicationRouteId,
            }"
            @change="changeMedicine"
          />
        </v-col>

        <v-col cols="3">
          <v-select
            v-model="presentationId"
            outlined
            dense
            label="Apresentação"
            :items="presentations"
            item-text="name"
            item-value="id"
            :hide-details="errors.presentation === undefined"
            :error-messages="errors.presentation"
            background-color="white"
            :disabled="allowEdit"
          />
        </v-col>

        <v-col cols="3">
          <v-row dense>
            <v-col cols="4" class="py-0">
              <v-text-field
                v-model="quantity"
                outlined
                dense
                hide-details
                label=""
                type="number"
                background-color="white"
                :disabled="allowEdit || continuous"
              />
            </v-col>

            <v-col cols="8" class="py-0">
              <v-select
                v-model="presentationUnityId"
                outlined
                dense
                label="Quantidade"
                :items="quantityUnities"
                item-text="name"
                item-value="id"
                :hide-details="errors.presentationUnityId === undefined"
                :error-messages="errors.presentationUnityId"
                background-color="white"
                :disabled="allowEdit || continuous"
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="3">
          <v-select
            v-model="applicationSiteId"
            outlined
            dense
            label="Local"
            :items="applicationSites"
            item-text="name"
            item-value="id"
            :hide-details="errors.applicationSite === undefined"
            :error-messages="errors.applicationSite"
            background-color="white"
            :disabled="allowEdit"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
            v-model="observation"
            outlined
            dense
            hide-details
            label="Observação"
            type="string"
            background-color="white"
            :disabled="allowEdit"
          />
        </v-col>
        <v-col cols="auto">
          <v-switch
            v-model="continuous"
            label="Uso Contínuo"
            :disabled="allowEdit"
            class="mt-1"
          />
        </v-col>
      </v-row>

      <v-row v-if="!allowEdit">
        <v-col>
          <span class="text-subtitle-2"> Novo Modo de aplicar </span>

          <PrescriptionFormItemAction
            :actionUnities="actionUnities"
            :addAction="addAction"
            :removeAction="removeAction"
            :prescriptionItemAction="newAction"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
          />
        </v-col>
      </v-row>

      <v-row v-if="prescriptionItemActions.length > 0">
        <v-col>
          <span class="text-subtitle-2"> Modos de aplicar </span>

          <PrescriptionFormItemAction
            v-for="prescriptionItemAction in prescriptionItemActions"
            :key="prescriptionItemAction.id"
            :addAction="addAction"
            :removeAction="removeAction"
            :prescriptionItemAction="prescriptionItemAction"
            :actionUnities="actionUnities"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            :showDelete="true"
            :visualization="allowEdit"
          />
        </v-col>
      </v-row>

      <v-row dense>
        <v-col cols="auto" v-if="allowEdit">
          <v-btn @click="edit = true" color="light-blue" dark>Editar</v-btn>
        </v-col>

        <v-col cols="auto" v-if="allowEdit">
          <v-btn @click="deleteItem" color="error" dark>Remover</v-btn>
        </v-col>

        <v-col cols="auto" v-else>
          <v-btn @click="saveItem" color="light-blue" dark>Salvar</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import PrescriptionFormItemAction from "./item_action.vue";
import QuerySearchDropdown from "@/components/ui/form/query_search_dropdown.vue";

import GET_MEDICINES_QUERY from "@/graphql/medicines.gql";

export default {
  name: "PrescriptionFormItem",
  components: {
    PrescriptionFormItemAction,
    QuerySearchDropdown,
  },
  props: {
    prescriptionItem: {
      type: Object,
      default: () => {
        return {
          medicine_application_route_id: "",
          medicine_application_site_id: "",
          medicine_id: "",
          medicine_presentation_id: "",
          medicine_presentation_unity_id: "",
          presentation_quantity: 1,
          observation: "",
          continuous: false,
          actions: [],
        };
      },
    },
    applicationRoute: Object,
    prescriptionFrequencies: Array,
    prescriptionPeriods: Array,
    prescriptionHowLongs: Array,
    addItem: Function,
    removeItem: Function,
    visualization: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      errors: {},
      getMedicinesQuery: GET_MEDICINES_QUERY,
      newAction: {
        key: "",
        medicine_presentation_action_id: "",
        prescription_frequency_id: "",
        prescription_how_long_id: "",
        prescription_period_id: null,
        presentation_action_quantity: 1,
      },
      edit: false,
      medicine: null,
    };
  },
  apollo: {
    medicine: {
      query: require("@/graphql/medicine/medicine.gql"),
      variables() {
        return {
          id: this.prescriptionItem.medicine_id,
        };
      },
      skip() {
        return !this.prescriptionItem.medicine_id;
      },
    },
  },
  watch: {
    medicine(medicine) {
      this.prescriptionItem.medicine_id = medicine.id;
    },
  },
  computed: {
    allowEdit() {
      if (this.visualization) {
        if (this.edit) {
          return !this.edit;
        }

        return this.visualization;
      }

      return this.visualization;
    },
    presentations() {
      if (this.applicationRoute) {
        return this.applicationRoute.presentations;
      }

      return [];
    },
    quantityUnities() {
      if (this.presentation) {
        return this.presentation.presentationUnities;
      }

      return [];
    },
    applicationSites() {
      return this.applicationRoute?.applicationSites || [];
    },
    actionUnities() {
      if (this.presentation) {
        return this.presentation.presentationActions;
      }

      return [];
    },
    applicationRouteId() {
      return this.applicationRoute?.id;
    },
    prescriptionItemActions: {
      set(actions) {
        this.prescriptionItem.actions = actions;
      },
      get() {
        return this.lodash
          .orderBy(this.prescriptionItem.actions, ["createdAt"], ["desc"])
          .map((e) => {
            return {
              ...e,
              key: this.$randomKey(),
            };
          });
      },
    },
    applicationSiteId: {
      set(value) {
        this.prescriptionItem.medicine_application_site_id = value;
      },
      get() {
        return this.prescriptionItem.medicine_application_site_id;
      },
    },
    presentationId: {
      set(value) {
        this.prescriptionItem.medicine_presentation_id = value;
      },
      get() {
        return this.prescriptionItem.medicine_presentation_id;
      },
    },
    presentation() {
      return this.lodash.find(this.presentations, { id: this.presentationId });
    },
    presentationUnityId: {
      set(value) {
        this.prescriptionItem.medicine_presentation_unity_id = value;
      },
      get() {
        return this.prescriptionItem.medicine_presentation_unity_id;
      },
    },
    quantity: {
      set(value) {
        this.prescriptionItem.presentation_quantity = value;
      },
      get() {
        return this.prescriptionItem.presentation_quantity;
      },
    },
    observation: {
      set(value) {
        this.prescriptionItem.observation = value;
      },
      get() {
        return this.prescriptionItem.observation;
      },
    },
    continuous: {
      set(value) {
        if (value) {
          this.quantity = 1;
        }
        this.$set(this.prescriptionItem, "continuous", value);
      },
      get() {
        return this.prescriptionItem.continuous;
      },
    },
  },
  methods: {
    changeMedicine() {
      if (!this.presentationId) {
        this.presentationId = this.lodash.first(this.presentations).id;
      }

      if (!this.quantity) {
        this.quantity = 1;
      }

      this.$nextTick(() => {
        if (!this.presentationUnityId) {
          this.presentationUnityId = this.lodash.first(this.quantityUnities).id;
        }
      });
    },
    validatePrescriptionItem() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (!this.medicine) {
        this.errors.medicine = errorMsg;
      }
      if (!this.presentationId) {
        this.errors.presentation = errorMsg;
      }
      if (!this.presentationUnityId) {
        this.errors.presentationUnityId = errorMsg;
      }
      if (!this.applicationSiteId) {
        this.errors.applicationSite = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    addAction(action) {
      let prescriptionItemActions = this.prescriptionItemActions;

      let actionIndex = this.lodash.findIndex(prescriptionItemActions, {
        key: action.key,
      });

      if (actionIndex === -1) {
        prescriptionItemActions.push({
          ...action,
          key: this.$randomKey(),
        });

        this.newAction = {
          ...this.newAction,
          key: "",
          prescription_frequency_id: "",
          prescription_how_long_id: "",
          prescription_period_id: "",
          presentation_action_quantity: 1,
        };
      } else {
        prescriptionItemActions[actionIndex] = action;
      }

      this.prescriptionItemActions = [];
      this.$nextTick(() => {
        this.prescriptionItemActions = prescriptionItemActions;
      });
    },
    removeAction(action) {
      let actionIndex = this.lodash.findIndex(this.prescriptionItem.actions, {
        key: action.key,
      });

      this.prescriptionItem.actions.splice(actionIndex, 1);
    },
    saveItem() {
      if (!this.validatePrescriptionItem()) return;

      this.prescriptionItem.medicine_application_route_id = this.applicationRoute.id;
      this.addItem(this.prescriptionItem);
      this.edit = false;
    },
    deleteItem() {
      if (confirm("Você realmente deseja deletar esse medicamento?")) {
        this.removeItem(this.prescriptionItem);
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
